import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import CloseIcon from '@material-ui/icons/Close';
import {
	IApply,
	IApprovalClassSearchCondition,
	IApprovalItem,
	IApprovalStayMealData,
	setApprovals,
	setApprovalStayMealList,
	setClassStayMealDialog,
	setStayMealCommment,
} from 'src/actions/search';
import SearchScenarioFactory, {
	IApplyCareersParam,
	ICancelAndUpdateClassParam,
	IStayMealSearchParam,
} from 'src/scenario/SearchScenarioFactory';
import { UpwardTransition } from 'src/utils';
import { Routes, Screens } from 'src/utils/Routes';
import {
	IApplication,
	IApplicationStayMeal,
	setChangeApplicationData,
	showChangeApplicationDialog,
} from '../actions/imstat';
import { IMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	ICancelApplicationParam,
	IFetchChangeApplicationParam,
} from '../scenario/ImstatScenarioFactory';
import { isMobile } from '../utils/MobileCheck';
import CareerStayMeal, {
	IClassStayMealInfo,
	IStayMealdata,
} from './CareerStayMeal';
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		button: {
			margin: '10px',
		},
		careerDialog: {
			width: '80%',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '150px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		changeButton: {
			marginLeft: '15px',
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '100%',
		},
		flex: {
			flex: 1,
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileChangeButton: {
			marginLeft: '5px',
			marginRight: '5px',
		},
		mobileTable: {
			minWidth: '100px',
		},
		paper: {
			minWidth: '700px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
		tableLayout: {
			tableLayout: 'fixed',
		},
		textArea: {
			width: '100%',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			'word-break': 'break-all',
		},
		width: {
			width: '100%',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: IState['careerID'];
	career_typeid: IState['careerTypeID'];
	class_id: IState['classID'];
}

interface IRouteState extends Pick<IState, 'reason'> {
	caller: Parameters<IProps['pushHistory']>[0];
	classId: IState['classID'];
}

interface IState {
	careerID: string;
	careerTypeID: string;
	classID: string;
	openErrorMessageDialog: boolean;
	messages: IMessage[];
	reason: any;
	stayMealData: IStayMealdata;
	setCancleStayMealFlg: boolean;
	approverId1: string | null;
	approverId2: string | null;
	approverId4: string | null;
}

/**
 * 受講申請変更
 */
class ImstatChangeApplication extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			approverId1: null,
			approverId2: null,
			approverId4: null,
			careerID: '',
			careerTypeID: '',
			classID: '',
			messages: [],
			openErrorMessageDialog: false,
			reason: '',
			setCancleStayMealFlg: true,
			stayMealData: {
				careerID: '',
				classId: '',
				dayMealAfternoon: '0',
				dayMealEvening: '0',
				dayMealMorning: '0',
				dayStay: '0',
				postMealAfternoon: '0',
				postMealEvening: '0',
				postMealMorning: '0',
				preMealAfternoon: '0',
				preMealEvening: '0',
				preMealMorning: '0',
				preStay: '0',
				sex: '0',
				smoking: '0',
			},
		};

		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.onDialogOk = this.onDialogOk.bind(this);
		this.onChangeReason = this.onChangeReason.bind(this);
		this.onChangeApprover = this.onChangeApprover.bind(this);
		this.onChangeApprover2 = this.onChangeApprover2.bind(this);
		this.changeApplication = this.changeApplication.bind(this);
		this.changeApplication2 = this.changeApplication2.bind(this);
		this.Approvalschange = this.Approvalschange.bind(this);
		this.handleopenStayMeal = this.handleopenStayMeal.bind(this);
		this.handleopenStayMealDialog = this.handleopenStayMealDialog.bind(
			this
		);
		this.handlecloseStayMealDialog = this.handlecloseStayMealDialog.bind(
			this
		);
		this.handleopenStayMealDialog2 = this.handleopenStayMealDialog2.bind(
			this
		);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (this.props.location.state.reason) {
			this.setState({
				reason: this.props.location.state.reason,
			});
		}

		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const careerTypeID = this.props.match.params.career_typeid;
		const classID = this.props.match.params.class_id;

		this.setState({
			careerID,
			careerTypeID,
			classID,
		});

		this.props.fetchChangeApplication(this.props.token, {
			careerID,
			classID,
			userAttr: this.props.userAttr,
		});
		if (this.props.location.state.classId) {
			const approvalData = this.props.approvalsData.filter(
				item => item.classId === this.props.location.state.classId
			)[0];
			this.setState({
				approverId1: approvalData.approverId1,
				approverId2: approvalData.approverId2,
				approverId4: approvalData.approverId4,
			});
		}
	}

	public render() {
		const { classes, data } = this.props;
		const showApprovers =
			data.approve1List || data.approve2List || data.approve4List;

		if (this.props.location.state.classId) {
			const approvalData = this.props.approvalsData.filter(
				item => item.classId === this.props.location.state.classId
			)[0];
			// 開催期間
			let period = approvalData.period;
			if (period === 'クラス指定なし') {
				period = i18n.t(period, {
					ns: 'force',
				});
			} else if (period && period.indexOf('年後まで開催') !== -1) {
				const kikan = period.substring(8, period.length - 6);
				period = i18n.t('ApplicationChange_0019', {
					kikan,
				});
			} else if (period && period.indexOf('日後まで開催') !== -1) {
				const kikan = period.substring(8, period.length - 6);
				period = i18n.t('ApplicationChange_0020', {
					kikan,
				});
			} else if (period && period.indexOf('～') !== -1) {
				period = period.replace(
					'～',
					i18n.t('～', {
						ns: 'force',
					})
				);
			}
			// 申込状況
			let mousikomiStatus = approvalData.capacityLabel;
			if (
				mousikomiStatus === 'クラス指定なし' ||
				mousikomiStatus === '定員未定'
			) {
				mousikomiStatus = i18n.t(mousikomiStatus, {
					ns: 'force',
				});
			} else if (
				mousikomiStatus &&
				mousikomiStatus.indexOf('：') !== -1
			) {
				mousikomiStatus =
					i18n.t(mousikomiStatus.substring(0, 2), {
						ns: 'force',
					}) +
					mousikomiStatus
						.substring(2, mousikomiStatus.length)
						.replace(
							'：定員',
							i18n.t('：定員', {
								ns: 'force',
							})
						);
			}
			return (
				<div className={classes.root}>
					<div className={classes.wrapDiv}>
						{!isMobile() && (
							<Paper className={classes.paper}>
								<Table
									className={this.props.classes.tableLayout}
								>
									<TableBody>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0001'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{approvalData.careerTitle}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0002'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{approvalData.classId ===
												'CL000000'
													? i18n.t(
															approvalData.className,
															{
																ns: 'force',
															}
													  )
													: approvalData.className}
												<Button
													variant="contained"
													color="primary"
													onClick={
														this.Approvalschange
													}
													className={
														classes.changeButton
													}
												>
													{i18n.t(
														'ApplicationChange_0003'
													)}
												</Button>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0004'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{period}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0005'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{mousikomiStatus}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0006'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<TextField
													id="multiline-flexible"
													className={classes.textArea}
													multiline={true}
													rows="4"
													margin="normal"
													value={this.state.reason}
													onChange={
														this.onChangeReason
													}
												/>
											</TableCell>
										</TableRow>
										{showApprovers && (
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'ApplicationChange_0007'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{data.approve1List && (
														<div>
															<InputLabel htmlFor="acceptManagerUserID">
																{i18n.t(
																	'ApplicationChange_0008'
																)}
															</InputLabel>
															<Select
																id="approverId1"
																input={
																	<Input
																		id="approverId1"
																		name="approverId1"
																	/>
																}
																autoWidth={true}
																onChange={
																	this
																		.onChangeApprover2
																}
																value={
																	approvalData.approverId1 ===
																	null
																		? ''
																		: approvalData.approverId1
																}
																displayEmpty={
																	true
																}
																classes={{
																	selectMenu: this
																		.props
																		.classes
																		.whiteSpace,
																}}
															>
																{approvalData.approverList1.map(
																	(
																		approver: any,
																		i: number
																	): JSX.Element => (
																		<MenuItem
																			key={
																				i
																			}
																			value={
																				approver.id
																			}
																			className={
																				this
																					.props
																					.classes
																					.whiteSpaceMenuItem
																			}
																		>
																			{i18n.t(
																				approver.name,
																				{
																					ns:
																						'force',
																				}
																			)}
																		</MenuItem>
																	)
																)}
															</Select>
														</div>
													)}
													{data.approve2List && (
														<div>
															<InputLabel htmlFor="acceptManagerUserID">
																{i18n.t(
																	'ApplicationChange_0009'
																)}
															</InputLabel>
															<Select
																id="approverId2"
																input={
																	<Input
																		id="approverId2"
																		name="approverId2"
																	/>
																}
																autoWidth={true}
																onChange={
																	this
																		.onChangeApprover2
																}
																value={
																	approvalData.approverId2 ===
																	null
																		? ''
																		: approvalData.approverId2
																}
																displayEmpty={
																	true
																}
																classes={{
																	selectMenu: this
																		.props
																		.classes
																		.whiteSpace,
																}}
															>
																{approvalData.approverList2.map(
																	(
																		approver: any,
																		i: number
																	): JSX.Element => (
																		<MenuItem
																			key={
																				i
																			}
																			value={
																				approver.id
																			}
																			className={
																				this
																					.props
																					.classes
																					.whiteSpaceMenuItem
																			}
																		>
																			{i18n.t(
																				approver.name,
																				{
																					ns:
																						'force',
																				}
																			)}
																		</MenuItem>
																	)
																)}
															</Select>
														</div>
													)}
													{data.approve4List && (
														<div>
															<InputLabel htmlFor="acceptManagerUserID">
																{i18n.t(
																	'ApplicationChange_0010'
																)}
															</InputLabel>
															<Select
																id="approverId4"
																input={
																	<Input
																		id="approverId4"
																		name="approverId4"
																	/>
																}
																autoWidth={true}
																onChange={
																	this
																		.onChangeApprover2
																}
																value={
																	approvalData.approverId4 ===
																	null
																		? ''
																		: approvalData.approverId4
																}
																displayEmpty={
																	true
																}
																classes={{
																	selectMenu: this
																		.props
																		.classes
																		.whiteSpace,
																}}
															>
																{approvalData.approverList4.map(
																	(
																		approver: any,
																		i: number
																	): JSX.Element => (
																		<MenuItem
																			key={
																				i
																			}
																			value={
																				approver.id
																			}
																			className={
																				this
																					.props
																					.classes
																					.whiteSpaceMenuItem
																			}
																		>
																			{i18n.t(
																				approver.name,
																				{
																					ns:
																						'force',
																				}
																			)}
																		</MenuItem>
																	)
																)}
															</Select>
														</div>
													)}
												</TableCell>
											</TableRow>
										)}
										{data.useFacilityFlg === 'Y' && (
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'ApplicationChange_0011'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{approvalData.stayMealFlg && (
														<Button
															variant="contained"
															color="primary"
															onClick={
																this
																	.handleopenStayMealDialog2
															}
														>
															{i18n.t(
																'ApplicationChange_0012'
															)}
														</Button>
													)}
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</Paper>
						)}
						{isMobile() && (
							<Paper>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0001')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{approvalData.careerTitle}
									</div>
									<div
										className={classes.mobileCellItemName}
										style={{
											justifyContent: 'space-between',
										}}
									>
										{i18n.t('ApplicationChange_0002')}
										<Button
											variant="contained"
											color="primary"
											onClick={this.Approvalschange}
											className={
												classes.mobileChangeButton
											}
										>
											{i18n.t('ApplicationChange_0003')}
										</Button>
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{approvalData.classId === 'CL000000'
											? i18n.t(approvalData.className, {
													ns: 'force',
											  })
											: approvalData.className}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0004')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{period}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0005')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{mousikomiStatus}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0006')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										<TextField
											id="multiline-flexible"
											className={classes.textArea}
											multiline={true}
											rows="4"
											margin="normal"
											value={this.state.reason}
											onChange={this.onChangeReason}
										/>
									</div>
									{showApprovers && (
										<>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18n.t(
													'ApplicationChange_0007'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
												style={{
													alignItems: 'flex-start',
													flexDirection: 'column',
												}}
											>
												{data.approve1List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ApplicationChange_0008'
															)}
														</InputLabel>
														<Select
															id="approverId1"
															input={
																<Input
																	id="approverId1"
																	name="approverId1"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover2
															}
															value={
																approvalData.approverId1 ===
																null
																	? ''
																	: approvalData.approverId1
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{approvalData.approverList1.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.id
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.name,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve2List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ApplicationChange_0009'
															)}
														</InputLabel>
														<Select
															id="approverId2"
															input={
																<Input
																	id="approverId2"
																	name="approverId2"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover2
															}
															value={
																approvalData.approverId2 ===
																null
																	? ''
																	: approvalData.approverId2
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{approvalData.approverList2.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.id
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.name,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve4List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ApplicationChange_0010'
															)}
														</InputLabel>
														<Select
															id="approverId4"
															input={
																<Input
																	id="approverId4"
																	name="approverId4"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover2
															}
															value={
																approvalData.approverId4 ===
																null
																	? ''
																	: approvalData.approverId4
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{approvalData.approverList4.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.id
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.name,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
											</div>
										</>
									)}
								</div>
							</Paper>
						)}
					</div>
					<div>
						<div className={classes.column}>
							<Button
								variant="contained"
								color="primary"
								onClick={this.changeApplication2}
							>
								{i18n.t('ApplicationChange_0013')}
							</Button>
						</div>
					</div>
					<MessageDialog
						open={this.props.dialogOpen}
						showCancelButton={false}
						title={i18n.t('ApplicationChange_0014')}
						contents={[{ content: 'LMCM_I_00530' }]}
						onClose={this.onDialogOk}
						onClickOk={this.onDialogOk}
					/>
					<MessageDialog
						open={this.state.openErrorMessageDialog}
						showCancelButton={false}
						title={i18n.t('ApplicationChange_0015')}
						contents={this.state.messages}
						onClose={this.errorMessageDialogClose}
						onClickOk={this.errorMessageDialogClose}
					/>
					<Dialog
						fullScreen={false}
						TransitionComponent={UpwardTransition}
						open={this.props.classStayMealDialog}
						onClose={this.handlecloseStayMealDialog}
						fullWidth={true}
						maxWidth={false}
						classes={{
							paperFullWidth: this.props.classes.careerDialog,
							scrollPaper: this.props.classes.scrollPaper,
						}}
					>
						<AppBar className={this.props.classes.appBar}>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="Close"
									onClick={this.handlecloseStayMealDialog}
								>
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" color="inherit">
									{i18n.t('ApplicationChange_0016')}
								</Typography>
							</Toolbar>
						</AppBar>
						<CareerStayMeal
							StayMealdata={this.state.stayMealData}
							comment={this.props.comment}
						/>
					</Dialog>
				</div>
			);
		} else {
			// 開催期間
			let kikan = data.kikan;
			if (kikan === 'クラス指定なし') {
				kikan = i18n.t(kikan, {
					ns: 'force',
				});
			} else if (kikan && kikan.indexOf('Y') !== -1) {
				kikan = kikan.substring(1, kikan.length);
				kikan = i18n.t('ApplicationChange_0019', {
					kikan,
				});
			} else if (kikan && kikan.indexOf('D') !== -1) {
				kikan = kikan.substring(1, kikan.length);
				kikan = i18n.t('ApplicationChange_0020', {
					kikan,
				});
			} else if (kikan && kikan.indexOf('～') !== -1) {
				kikan = kikan.replace(
					'～',
					i18n.t('～', {
						ns: 'force',
					})
				);
			}
			// 申込状況
			// 申込状況
			let mousikomiStatus = data.capacity;
			if (
				mousikomiStatus === 'クラス指定なし' ||
				mousikomiStatus === '定員未定'
			) {
				mousikomiStatus = i18n.t(mousikomiStatus, {
					ns: 'force',
				});
			} else if (
				mousikomiStatus &&
				mousikomiStatus.indexOf('：') !== -1
			) {
				mousikomiStatus =
					i18n.t(mousikomiStatus.substring(0, 2), {
						ns: 'force',
					}) +
					mousikomiStatus
						.substring(2, mousikomiStatus.length)
						.replace(
							'：定員',
							i18n.t('：定員', {
								ns: 'force',
							})
						);
			}
			return (
				<div className={classes.root}>
					<div className={classes.wrapDiv}>
						{!isMobile() && (
							<Paper className={classes.paper}>
								<Table
									className={this.props.classes.tableLayout}
								>
									<TableBody>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0001'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{data.careerTitle}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0002'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{data.className &&
												data.className ===
													'個別指定クラス'
													? i18n.t(data.className, {
															ns: 'force',
													  })
													: data.className}
												<Button
													variant="contained"
													color="primary"
													onClick={
														this.Approvalschange
													}
													className={
														classes.changeButton
													}
												>
													{i18n.t(
														'ApplicationChange_0003'
													)}
												</Button>
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0004'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{kikan}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0005'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{mousikomiStatus}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'ApplicationChange_0006'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												<TextField
													id="multiline-flexible"
													className={classes.textArea}
													multiline={true}
													rows="4"
													margin="normal"
													value={data.reason}
													onChange={
														this.onChangeReason
													}
												/>
											</TableCell>
										</TableRow>
										{showApprovers && (
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'ApplicationChange_0007'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{data.approve1List && (
														<div>
															<InputLabel htmlFor="acceptManagerUserID">
																{i18n.t(
																	'ApplicationChange_0008'
																)}
															</InputLabel>
															<Select
																id="approverId1"
																input={
																	<Input
																		name="acceptManagerUserID"
																		id="acceptManagerUserID"
																	/>
																}
																autoWidth={true}
																onChange={
																	this
																		.onChangeApprover
																}
																value={
																	data.acceptManagerUserID
																}
																displayEmpty={
																	true
																}
																classes={{
																	selectMenu: this
																		.props
																		.classes
																		.whiteSpace,
																}}
															>
																{data.approve1List.map(
																	(
																		approver: any,
																		i: number
																	): JSX.Element => (
																		<MenuItem
																			key={
																				i
																			}
																			value={
																				approver.userId
																			}
																			className={
																				this
																					.props
																					.classes
																					.whiteSpaceMenuItem
																			}
																		>
																			{i18n.t(
																				approver.approverOptionString,
																				{
																					ns:
																						'force',
																				}
																			)}
																		</MenuItem>
																	)
																)}
															</Select>
														</div>
													)}
													{data.approve2List && (
														<div>
															<InputLabel htmlFor="acceptManagerUserID">
																{i18n.t(
																	'ApplicationChange_0009'
																)}
															</InputLabel>
															<Select
																id="approverId2"
																input={
																	<Input
																		name="acceptManagerUserID2"
																		id="acceptManagerUserID2"
																	/>
																}
																autoWidth={true}
																onChange={
																	this
																		.onChangeApprover
																}
																value={
																	data.acceptManagerUserID2
																}
																displayEmpty={
																	true
																}
																classes={{
																	selectMenu: this
																		.props
																		.classes
																		.whiteSpace,
																}}
															>
																{data.approve2List.map(
																	(
																		approver: any,
																		i: number
																	): JSX.Element => (
																		<MenuItem
																			key={
																				i
																			}
																			value={
																				approver.userId
																			}
																			className={
																				this
																					.props
																					.classes
																					.whiteSpaceMenuItem
																			}
																		>
																			{i18n.t(
																				approver.approverOptionString,
																				{
																					ns:
																						'force',
																				}
																			)}
																		</MenuItem>
																	)
																)}
															</Select>
														</div>
													)}
													{data.approve4List && (
														<div>
															<InputLabel htmlFor="acceptManagerUserID">
																{i18n.t(
																	'ApplicationChange_0010'
																)}
															</InputLabel>
															<Select
																id="approverId4"
																input={
																	<Input
																		name="acceptManagerUserID4"
																		id="acceptManagerUserID4"
																	/>
																}
																autoWidth={true}
																onChange={
																	this
																		.onChangeApprover
																}
																value={
																	data.acceptManagerUserID4
																}
																displayEmpty={
																	true
																}
																classes={{
																	selectMenu: this
																		.props
																		.classes
																		.whiteSpace,
																}}
															>
																{data.approve4List.map(
																	(
																		approver: any,
																		i: number
																	): JSX.Element => (
																		<MenuItem
																			key={
																				i
																			}
																			value={
																				approver.userId
																			}
																			className={
																				this
																					.props
																					.classes
																					.whiteSpaceMenuItem
																			}
																		>
																			{i18n.t(
																				approver.approverOptionString,
																				{
																					ns:
																						'force',
																				}
																			)}
																		</MenuItem>
																	)
																)}
															</Select>
														</div>
													)}
												</TableCell>
											</TableRow>
										)}
										{data.useFacilityFlg === 'Y' && (
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'ApplicationChange_0011'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{data.stayMealFlg && (
														<Button
															variant="contained"
															color="primary"
															onClick={
																this
																	.handleopenStayMealDialog
															}
														>
															{i18n.t(
																'ApplicationChange_0012'
															)}
														</Button>
													)}
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</Paper>
						)}
						{isMobile() && (
							<Paper>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0001')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{data.careerTitle}
									</div>
									<div
										className={classes.mobileCellItemName}
										style={{
											justifyContent: 'space-between',
										}}
									>
										{i18n.t('ApplicationChange_0002')}
										<Button
											variant="contained"
											color="primary"
											onClick={this.Approvalschange}
											className={
												classes.mobileChangeButton
											}
										>
											{i18n.t('ApplicationChange_0003')}
										</Button>
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{data.className &&
										data.className === '個別指定クラス'
											? i18n.t(data.className, {
													ns: 'force',
											  })
											: data.className}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0004')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{kikan}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0005')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{mousikomiStatus}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('ApplicationChange_0006')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										<TextField
											id="multiline-flexible"
											className={classes.textArea}
											multiline={true}
											rows="4"
											margin="normal"
											value={data.reason}
											onChange={this.onChangeReason}
										/>
									</div>
									{showApprovers && (
										<>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18n.t(
													'ApplicationChange_0007'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
												style={{
													alignItems: 'flex-start',
													flexDirection: 'column',
												}}
											>
												{data.approve1List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ApplicationChange_0008'
															)}
														</InputLabel>
														<Select
															id="approverId1"
															input={
																<Input
																	name="acceptManagerUserID"
																	id="acceptManagerUserID"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover
															}
															value={
																data.acceptManagerUserID
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve1List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve2List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ApplicationChange_0009'
															)}
														</InputLabel>
														<Select
															id="approverId2"
															input={
																<Input
																	name="acceptManagerUserID2"
																	id="acceptManagerUserID2"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover
															}
															value={
																data.acceptManagerUserID2
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve2List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve4List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'ApplicationChange_0010'
															)}
														</InputLabel>
														<Select
															id="approverId4"
															input={
																<Input
																	name="acceptManagerUserID4"
																	id="acceptManagerUserID4"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover
															}
															value={
																data.acceptManagerUserID4
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve4List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
											</div>
										</>
									)}
								</div>
							</Paper>
						)}
					</div>
					<div>
						<div className={classes.column}>
							<Button
								variant="contained"
								color="primary"
								onClick={this.changeApplication}
							>
								{i18n.t('ApplicationChange_0013')}
							</Button>
						</div>
					</div>
					<MessageDialog
						open={this.props.dialogOpen}
						showCancelButton={false}
						title={i18n.t('ApplicationChange_0014')}
						contents={[{ content: 'LMCM_I_00530' }]}
						onClose={this.onDialogOk}
						onClickOk={this.onDialogOk}
					/>
					<MessageDialog
						open={this.state.openErrorMessageDialog}
						showCancelButton={false}
						title={i18n.t('ApplicationChange_0015')}
						contents={this.state.messages}
						onClose={this.errorMessageDialogClose}
						onClickOk={this.errorMessageDialogClose}
					/>
					<Dialog
						fullScreen={false}
						TransitionComponent={UpwardTransition}
						open={this.props.classStayMealDialog}
						onClose={this.handlecloseStayMealDialog}
						fullWidth={true}
						maxWidth={false}
						classes={{
							paperFullWidth: this.props.classes.careerDialog,
							scrollPaper: this.props.classes.scrollPaper,
						}}
					>
						<AppBar className={this.props.classes.appBar}>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="Close"
									onClick={this.handlecloseStayMealDialog}
								>
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" color="inherit">
									{i18n.t('ApplicationChange_0016')}
								</Typography>
							</Toolbar>
						</AppBar>
						<CareerStayMeal
							StayMealdata={this.state.stayMealData}
							comment={''}
						/>
					</Dialog>
				</div>
			);
		}
	}

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}

	protected handlecloseStayMealDialog() {
		this.props.setClassStayMealDialog(false);
	}

	protected handleopenStayMeal() {
		if (this.state.setCancleStayMealFlg) {
			if (this.props.cancelStayMealList.length > 0) {
				this.setState({
					setCancleStayMealFlg: false,
				});
				const tempList = JSON.parse(
					JSON.stringify(this.props.approvalStayMealList)
				);
				const stayMealList = this.props.cancelStayMealList;
				const StayMealDateList: IClassStayMealInfo[] = [];
				// tslint:disable-next-line:prefer-for-of
				for (let index = 0; index < stayMealList.length; index++) {
					const StayMealDate: IClassStayMealInfo = {
						ExecutionDate: stayMealList[index].executionDate,
						MealAfternoonFlg: stayMealList[index].mealAfternoonFlg,
						MealEveningFlg: stayMealList[index].mealEveningFlg,
						MealMorningFlg: stayMealList[index].mealMorningFlg,
						StayFlg: stayMealList[index].stayFlg,
					};
					StayMealDateList.push(StayMealDate);
				}
				const StayMealData: IApprovalStayMealData = {
					careerID: this.props.match.params.career_id,
					classID: this.props.match.params.class_id,

					Comment: stayMealList[0].comment,
					SexFlg: stayMealList[0].sexFlg,
					SmokingFlg: stayMealList[0].smokingFlg,
					StayMealDateList,
					UID: this.props.userAttr.userId,
				};
				tempList.push(StayMealData);
				this.props.setApprovalStayMealList(tempList);
			}
		}
		const stayMealDataTemp: IStayMealdata = {
			careerID: this.state.careerID,
			classId: this.state.classID,
			dayMealAfternoon: this.props.data.dayMealAfternoon,
			dayMealEvening: this.props.data.dayMealEvening,
			dayMealMorning: this.props.data.dayMealMorning,
			dayStay: this.props.data.dayStay,
			postMealAfternoon: this.props.data.postMealAfternoon,
			postMealEvening: this.props.data.postMealEvening,
			postMealMorning: this.props.data.postMealMorning,
			preMealAfternoon: this.props.data.preMealAfternoon,
			preMealEvening: this.props.data.preMealEvening,
			preMealMorning: this.props.data.preMealMorning,
			preStay: this.props.data.preStay,
			sex: this.props.data.sex,
			smoking: this.props.data.smoking,
		};
		const param: IStayMealSearchParam = {
			careerId: this.state.careerID,
			classId: this.state.classID,
		};
		if (this.props.cancelStayMealList.length > 0) {
			if (
				this.props.cancelStayMealList[0].comment &&
				this.props.cancelStayMealList[0].comment !== '' &&
				this.props.comment === '' &&
				this.props.setCommentFlg === false
			) {
				this.props.stayMealComment(
					this.props.cancelStayMealList[0].comment
				);
			}
		}
		this.props.fetchStayMealDateList(this.props.token, param);
		this.setState({
			stayMealData: stayMealDataTemp,
		});
	}
	protected handleopenStayMealDialog() {
		this.handleopenStayMeal();
		this.props.setClassStayMealDialog(true);
	}

	protected handleopenStayMealDialog2() {
		if (
			this.props.location.state.classId &&
			this.props.location.state.classId !==
				this.props.match.params.class_id
		) {
			const approvalData = this.props.approvalsData.filter(
				item => item.classId === this.props.location.state.classId
			)[0];
			const stayMealDataTemp: IStayMealdata = {
				careerID: approvalData.careerId,
				classId: approvalData.classId,
				dayMealAfternoon: approvalData.dayMealAfternoon,
				dayMealEvening: approvalData.dayMealEvening,
				dayMealMorning: approvalData.dayMealMorning,
				dayStay: approvalData.dayStay,
				postMealAfternoon: approvalData.postMealAfternoon,
				postMealEvening: approvalData.postMealEvening,
				postMealMorning: approvalData.postMealMorning,
				preMealAfternoon: approvalData.preMealAfternoon,
				preMealEvening: approvalData.preMealEvening,
				preMealMorning: approvalData.preMealMorning,
				preStay: approvalData.preStay,
				sex: approvalData.sex,
				smoking: approvalData.smoking,
			};
			const param: IStayMealSearchParam = {
				careerId: approvalData.careerId,
				classId: approvalData.classId,
			};
			this.props.fetchStayMealDateList(this.props.token, param);

			this.setState({
				stayMealData: stayMealDataTemp,
			});
			if (this.props.cancelStayMealList.length > 0) {
				if (
					this.props.cancelStayMealList[0].comment &&
					this.props.cancelStayMealList[0].comment !== '' &&
					this.props.comment === '' &&
					this.props.setCommentFlg === false
				) {
					this.props.stayMealComment(
						this.props.cancelStayMealList[0].comment
					);
				}
			}
		} else {
			this.handleopenStayMeal();
		}
		this.props.setClassStayMealDialog(true);
	}

	/**
	 * メッセージダイアログと受講申請変更画面をクローズ
	 */
	protected onDialogOk() {
		this.props.onClose();
		this.props.setApprovalStayMealList([]);
		this.props.setChangeApplicationData({});
		this.props.pushHistory(this.props.location.state.caller);
	}

	/**
	 * 申請理由変更ハンドラ
	 * @param event
	 */
	protected onChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
		const { data } = this.props;
		const newData = Object.assign({}, data);
		newData.reason = event.target.value;
		this.setState({
			reason: event.target.value,
		});
		this.props.setChangeApplicationData(newData);
	}

	/**
	 * 承認者変更ハンドラ
	 * @param event
	 */
	protected onChangeApprover(event: React.ChangeEvent<HTMLSelectElement>) {
		const { data } = this.props;
		const { name, value } = event.target;
		const newData = Object.assign({}, data);
		newData[name] = value;
		this.props.setChangeApplicationData(newData);

		if (name === 'acceptManagerUserID') {
			this.setState({
				approverId1: value,
			});
		}
		if (name === 'acceptManagerUserID2') {
			this.setState({
				approverId2: value,
			});
		}
		if (name === 'acceptManagerUserID4') {
			this.setState({
				approverId4: value,
			});
		}
	}

	protected onChangeApprover2(event: React.ChangeEvent<HTMLSelectElement>) {
		const newApprovals = JSON.parse(
			JSON.stringify(this.props.approvalsData)
		);
		const { name, value } = event.target;
		const classIdTemp = this.props.location.state.classId;
		if (name && name !== '' && classIdTemp && classIdTemp !== '') {
			// tslint:disable-next-line: prefer-for-of
			for (let index = 0; index < newApprovals.length; index++) {
				if (newApprovals[index]['classId'] === classIdTemp) {
					newApprovals[index][name] = value;
					this.props.setApprovals(newApprovals);
				}
			}

			if (name === 'approverId1') {
				this.setState({
					approverId1: value,
				});
			}
			if (name === 'approverId2') {
				this.setState({
					approverId2: value,
				});
			}
			if (name === 'approverId4') {
				this.setState({
					approverId4: value,
				});
			}
		}
	}

	/**
	 * クラス変更ハンドラ
	 * @param event
	 */
	protected Approvalschange(event: React.MouseEvent<HTMLElement>) {
		const param: IApprovalClassSearchCondition = {
			careerType: '0',
			targetCareerId: this.state.careerID,
		};
		this.props.fetchClassApprovals(this.props.token, param);
		const to = Routes.getPath(Screens.PERSONAL_CLASS_APPROVALS_CHANGE);
		if (this.props.location.state.classId) {
			const state = {
				approverId1: this.state.approverId1,
				approverId2: this.state.approverId2,
				approverId4: this.state.approverId4,
				caller: this.props.location.state.caller,
				careerID: this.state.careerID,
				careerTypeID: this.state.careerTypeID,
				classId: this.state.classID,
				preClassID: this.props.location.state.classId,
				reason: this.state.reason,
			};
			this.props.pushHistoryState(to, state);
		} else {
			const state = {
				approverId1: this.props.data.acceptManagerUserID,
				approverId2: this.props.data.acceptManagerUserID2,
				approverId4: this.props.data.acceptManagerUserID4,
				caller: this.props.location.state.caller,
				careerID: this.state.careerID,
				careerTypeID: this.state.careerTypeID,
				classId: this.state.classID,
				reason: this.props.data.reason,
			};
			this.props.pushHistoryState(to, state);
		}
	}

	/**
	 * 申請理由変更ハンドラ
	 * @param event
	 */
	protected changeApplication(event: React.MouseEvent<HTMLElement>) {
		const { data, userAttr, token } = this.props;
		const { careerID, classID } = this.state;

		// 入力チェック
		if (data.reason && data.reason.length > 200) {
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('ApplicationChange_0006'), '200'],
			};
			this.setState({
				messages: [message],
				openErrorMessageDialog: true,
			});
			return;
		}

		const stayMealData: IApprovalStayMealData[] = [];
		const tempStayMealList = JSON.parse(
			JSON.stringify(this.props.approvalStayMealList)
		);
		// tslint:disable-next-line:prefer-for-of
		for (let xindex = 0; xindex < tempStayMealList.length; xindex++) {
			if (
				tempStayMealList[xindex].careerID === careerID &&
				tempStayMealList[xindex].classID === classID
			) {
				stayMealData.push(tempStayMealList[xindex]);
			}
		}

		const application: IApplication = {
			...data,
			careerID,
			classID,
			lang: userAttr.lang,
			locale: userAttr.locale,
			userId: userAttr.userId,
		};

		const applicationStayMeal: IApplicationStayMeal = {
			application,
			stayMealData,
		};
		this.props.saveChangeApplication(token, applicationStayMeal);
	}

	protected changeApplication2(event: React.MouseEvent<HTMLElement>) {
		const { data, token } = this.props;
		const { careerID } = this.state;

		// 入力チェック
		if (data.reason && data.reason.length > 200) {
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('ApplicationChange_0006'), '200'],
			};
			this.setState({
				messages: [message],
				openErrorMessageDialog: true,
			});
			return;
		}

		const stayMealData: IApprovalStayMealData[] = [];
		const tempStayMealList = JSON.parse(
			JSON.stringify(this.props.approvalStayMealList)
		);
		// tslint:disable-next-line:prefer-for-of
		for (let xindex = 0; xindex < tempStayMealList.length; xindex++) {
			if (
				tempStayMealList[xindex].careerID === careerID &&
				tempStayMealList[xindex].classID ===
					this.props.location.state.classId
			) {
				stayMealData.push(tempStayMealList[xindex]);
			}
		}

		const selectable = this.props.approvalsData.filter(
			item => item.classId === this.props.location.state.classId
		);

		let careerType = 0;
		const applies: IApply[] = selectable.map(
			(approval: IApprovalItem): IApply => {
				careerType = approval.careerType;
				return {
					approverId1: approval.approverId1,
					approverId2: approval.approverId2,
					approverId4: approval.approverId4,
					cancelWaitFlg: !!approval.cancel,
					careerId: approval.careerId,
					classId: approval.classId,
					stayMealData,
				};
			}
		);
		const applParam: IApplyCareersParam = {
			applies,
			careerType,
			reason: this.state.reason,
		};

		const cancelParam: ICancelApplicationParam = {
			aplType: '0',
			careerID: this.state.careerID,
			classID: this.state.classID,
			userAttr: this.props.userAttr,
		};
		const param: ICancelAndUpdateClassParam = {
			careerAppl: applParam,
			reqCancelReq: cancelParam,
		};

		this.props.updateApplyCareers(token, param);
	}
}

const mapStateToProps = (state: IRootState) => ({
	approvalStayMealList: state.search.approvalStayMealList,
	approvalsData: state.search.approvals.data,
	cancelStayMealList: state.imstat.cancleStayMealdata,
	classStayMealDialog: state.search.OpenClassStayMealDialog,
	comment: state.search.stayMealComment,
	data: state.imstat.changeApplication.data,
	dialogOpen: state.imstat.changeApplication.dialogOpen,
	isOpenApprovalResult: state.search.isOpenApprovalResult,
	setCommentFlg: state.search.setCommentFlg,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchChangeApplication: (
		token: string,
		arg: IFetchChangeApplicationParam
	) => {
		const s = ImstatScenarioFactory.createFetchChangeApplication(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchClassApprovals: (
		token: string,
		arg: IApprovalClassSearchCondition
	) => {
		const s = SearchScenarioFactory.createFetchClassApprovals(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchStayMealDateList: (token: string, arg: IStayMealSearchParam) => {
		const s = SearchScenarioFactory.FetchClassStayMealDateList(
			dispatch,
			token
		);
		s.run(arg);
	},
	onClose: () => dispatch(showChangeApplicationDialog({ dialogOpen: false })),
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	saveChangeApplication: (token: string, arg: IApplicationStayMeal) => {
		const s = ImstatScenarioFactory.createSaveChangeApplication(
			dispatch,
			token
		);
		s.run(arg);
	},
	setApprovalStayMealList: (approvalStayMealList: IApprovalStayMealData[]) =>
		dispatch(setApprovalStayMealList({ approvalStayMealList })),
	setApprovals: (data: IApprovalItem[]) => dispatch(setApprovals({ data })),
	setChangeApplicationData: (data: IApplication) =>
		dispatch(setChangeApplicationData({ data })),
	setClassStayMealDialog: (OpenClassStayMealDialog: boolean) =>
		dispatch(setClassStayMealDialog({ OpenClassStayMealDialog })),
	stayMealComment: (comment: string) =>
		dispatch(setStayMealCommment({ comment })),
	updateApplyCareers: (token: string, param: ICancelAndUpdateClassParam) => {
		const s = SearchScenarioFactory.createUpdateApplyCareers(
			dispatch,
			token
		);
		s.run(param);
	},
});

// tslint:disable-next-line: no-empty-interface
export interface IImstatChangeApplicationProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IImstatChangeApplicationProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatChangeApplication);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IImstatChangeApplicationProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/ApplicationChange.tsx